import {createContext, useContext, useEffect, useState} from "react";

const ApiContext = createContext({})

export function ApiProvider({children})  {
    const getToken = async () => {
        const url = window.ein.admin_url
        const nonce = window.ein.ajax_nonce
        const action = 'ein_get_token'
        const formData = new FormData()

        formData.set('_ajax_nonce', nonce)
        formData.set('action', action)

        const response = await fetch(url, {
            method: "POST",
            body: formData
        });

        if (!response.ok) {
            throw new Error(`Auth failed: ${response.status}`);
        }

        const json = await response.json();

        if (!json.data?.token) {
            throw new Error(`Auth failed: ${json.data.message || 'Unknown error'}`);
        }

        return json.data.token;
    }
    const [loading, setLoading] = useState(false);
    const [api, setApi] = useState(null)

    useEffect(() => {
        setApi(new ApiAdapter({
            baseUrl: window.ein.api_url,
            getToken
        }))
    }, [])

    return (
        <ApiContext value={{api, loading, setLoading}}>
            {children}
        </ApiContext>
    )
}

export function useApi() {
    return useContext(ApiContext)
}
class ApiAdapter {

    constructor({ baseUrl, getToken }) {
        this.baseUrl = baseUrl;
        this.getToken = getToken; // A function that returns the current auth token
        this.token = null
        this.token_expiry = null
    }

    async request(endpoint, { method = "GET", body, headers = {} } = {}) {
        try {

            const url = `${this.baseUrl}${endpoint}`;

            const now = new Date().getTime()

            if (!this.token || this.token && now > this.token_expiry) {
                const expiry_minutes = 15
                this.token = await this.getToken()
                this.token_expiry = new Date(now + (expiry_minutes * 60 * 1000)).getTime()
            }

            const config = {
                method,
                headers: {
                    "Content-Type": "application/json",
                    ...(this.token ? { Authorization: `Bearer ${this.token}` } : {}),
                    ...headers,
                },
                ...(body ? { body: JSON.stringify(body) } : {}),
            };

            const response = await fetch(url, config);
            const data = await this.safeParseJSON(response);

            // Handle HTTP-level errors
            if (!response.ok) {
                console.log(response, data)
                throw new Error(data.message || data.error || 'Bad Response: ' + response.status);
            }

            return data

        } catch (error) {
            throw error;
        }
    }

    async safeParseJSON(response) {
        try {
            return await response.json();
        } catch {
            return null; // Sometimes there’s no JSON body
        }
    }

    get(endpoint, options) {
        return this.request(endpoint, { method: "GET", ...options });
    }

    post(endpoint, body, options) {
        return this.request(endpoint, { method: "POST", body, ...options });
    }
}

export default ApiAdapter;
